import { useQuery, gql } from "@apollo/client"

export const PTO_INFO_QUERY = gql(`
  query ptoInfoQuery($engagementId: ID!, $offboardingDate: String) {
    ptoInfo(engagementId: $engagementId, offboardingDate: $offboardingDate) {
      daysRemaining
      daysTaken
      daysApproved
      leaveYear
      timeOffManagementEnabled
    }
  }
`)

export const usePtoInfo = (engagementId: string, offboardingDate: string) => {
  const { data, error, loading } = useQuery(PTO_INFO_QUERY, {
    variables: { engagementId, offboardingDate },
  })

  return { data, error, loading }
}
